import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FORM_REFS } from '../../../constants';
import { aemHostClient, eapiClient } from '../../../restClient';
import { formatEchannelResponse, isEmptyObject, prepareEchannelPayload, Translations } from '../../../utils';
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import { hideActionButton } from '../../layouts/actions/actionCreator';
import { updateCase } from '../actions/actionCreator';

const ConvertEchannel = (props) => {
  const [existingEntityData, setExistingEntityData] = useState([]);
  const [formJson, setFormJson] = useState();
  const [formData, setFormData] = useState();

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    let apiURL = "/aemData/formData/json_convert-echannel";
    (async () => {
      const { data } = await aemHostClient(apiURL);
      setFormJson(data)
    })();


    let _caseId = props.currentEchannel.caseId
    let _url = "/entities/existing-organisations/" + _caseId;
    (async () => {
      const { data } = await eapiClient(_url);
      setExistingEntityData(data.responseData)
    })();
  }, [])

  const getFormData = (formData) => {
    setFormData(formData)
  }

  const onFormSubmit = async (event, apiURL) => {
    const requestData = prepareEchannelPayload({ ...formData }, props.currentEchannel.caseId);

    if (props.currentEchannel.tempRefrenceId) {
      requestData.tempRefrenceId = props.currentEchannel.tempRefrenceId;
    } else if (formData.newEchannel === true) {
      const { data: tempRefIdResponse } = await eapiClient("/product/echannel/case/" + props.currentEchannel.caseId + "/tempRef")
      if (tempRefIdResponse.responseData && tempRefIdResponse.responseData.tempRefrenceId) {
        requestData.tempRefrenceId = tempRefIdResponse.responseData.tempRefrenceId
      }
    }
    if (requestData.newEchannel === true && requestData.other === false) {
      delete requestData.other
    }

    try {
      await eapiClient(apiURL, { method: "POST", data: JSON.stringify(requestData) })
      await eapiClient("/product/echannels/" + props.currentEchannel.id, { method: 'DELETE' })
      props.history.push("/case-body")
    } catch (error) {
      console.error(error);
    }
  }

  const onFormCancel = () => {
    props.history.goBack();
  }

  const renderFormGroups = () => {
    const { country, profileOwner, newEchannel, eChannelType, swiftBIC } = props.currentEchannel || {}
    const formData = formatEchannelResponse({ country, profileOwner, newEchannel, eChannelType, swiftBIC });
    if (formData.newEchannel === false && !("other" in formData)) {
      formData.other = false
    }
    const properties = {
      echannelId: props.match.params.echannelId,
      // caseId: props.currentEchannel.caseId,
      formData,
      existingEntityData: existingEntityData,
      editType: 'convert-echannel',
      pathname: props.history.location.pathname
    };
    if (formJson !== undefined && formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={props.mode}
          properties={properties}
          url={FORM_REFS[formJson.par.aemform_.formRef]}
          getFormData={getFormData}
          onFormSubmit={onFormSubmit}
          onFormCancel={onFormCancel}
          lang={props.lang.currentLang.lang}
          translatedData={props.lang.translatedData}
          flag={props.lang.currentLangFlag.flag} />
      );
    }
  }

  const pageTitle = formJson ? formJson.par.page_title_mainTitle : '';
  return (
    (pageTitle !== undefined ?
      <div>
        <div className="form-container">
          <div className="form-title">
            <h2 className="form-heading">{translations(pageTitle.pageHeading)}</h2>
            <p className="form-required-desc">{translations(pageTitle.descriptionText)}</p>
          </div>
          {renderFormGroups()}
        </div>
      </div>
      : ''));

}

const mapStateToProps = (state, props) => {
  const currentEchannel = props.location.state.currentEchannel;
  if (!currentEchannel) {
    props.history.goBack();
  }
  return {
    cases: state.cases,
    lang: state.lang,
    currentEchannel,
    mode: !isEmptyObject(currentEchannel) ? 'edit' : ''
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    }
  }
}

ConvertEchannel.propTypes = {
  cases: PropTypes.object,
  lang: PropTypes.object,
  mode: PropTypes.object,
  history: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertEchannel);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddEchannel/ConvertEchannel.js